import { render, staticRenderFns } from "./NotesPopup.vue?vue&type=template&id=4f400bf6&scoped=true&"
import script from "./NotesPopup.vue?vue&type=script&lang=js&"
export * from "./NotesPopup.vue?vue&type=script&lang=js&"
import style0 from "./NotesPopup.vue?vue&type=style&index=0&id=4f400bf6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f400bf6",
  null
  
)

export default component.exports